/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { Country } from '../models/Country';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class CountryService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns Country
     * @throws ApiError
     */
    public countryGet(): Observable<Array<Country>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/countries',
        });
    }
    /**
     * @returns Country
     * @throws ApiError
     */
    public countryGetActiveCountries(): Observable<Array<Country>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/countries/active',
        });
    }
}
